module.exports = __webpack_public_path__ + "img/no-address.5c0fad28.svg";